import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface MenuGroup {
    id: string;
    nombre: string;
    orden: number;
    integration: boolean;
    urlToken: string | null;
    /** true si hay una api_key cargada. El valor real nunca viaja al frontend. */
    hasApiKey: boolean;
    /** true si hay una session_api_key (clave de sesiones) cargada. Nunca viaja al frontend. */
    hasSessionApiKey: boolean;
    createdAt: string;
    updatedAt?: string;
}

export interface CreateMenuGroupRequest {
    nombre: string;
    orden?: number;
    integration?: boolean;
    url_token?: string | null;
    api_key?: string;
    session_api_key?: string;
}

export interface UpdateMenuGroupRequest {
    nombre?: string;
    orden?: number;
    integration?: boolean;
    url_token?: string | null;
    /** Omitir = no modificar la existente. String vacío = borrarla. */
    api_key?: string;
    /** Omitir = no modificar la existente. String vacío = borrarla. */
    session_api_key?: string;
}

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    timestamp: string;
}

@Injectable({
    providedIn: 'root',
})
export class MenuGroupService {
    private apiUrl = `${environment.apiUrl}/v1`;

    constructor(
        // eslint-disable-next-line no-unused-vars
        private http: HttpClient
    ) {}

    getMenuGroups(): Observable<ApiResponse<MenuGroup[]>> {
        const url = `${this.apiUrl}/menu-groups`;
        return this.http.get<ApiResponse<MenuGroup[]>>(url, {
            headers: this.getAuthHeaders(),
        });
    }

    getMenuGroupById(id: string): Observable<ApiResponse<MenuGroup>> {
        const url = `${this.apiUrl}/menu-groups/${id}`;
        return this.http.get<ApiResponse<MenuGroup>>(url, {
            headers: this.getAuthHeaders(),
        });
    }

    createMenuGroup(data: CreateMenuGroupRequest): Observable<ApiResponse<MenuGroup>> {
        const url = `${this.apiUrl}/menu-groups`;
        return this.http.post<ApiResponse<MenuGroup>>(url, data, {
            headers: this.getAuthHeaders(),
        });
    }

    updateMenuGroup(id: string, data: UpdateMenuGroupRequest): Observable<ApiResponse<MenuGroup>> {
        const url = `${this.apiUrl}/menu-groups/${id}`;
        return this.http.put<ApiResponse<MenuGroup>>(url, data, {
            headers: this.getAuthHeaders(),
        });
    }

    deleteMenuGroup(id: string): Observable<ApiResponse<void>> {
        const url = `${this.apiUrl}/menu-groups/${id}`;
        return this.http.delete<ApiResponse<void>>(url, {
            headers: this.getAuthHeaders(),
        });
    }

    private getAuthToken(): string | null {
        return localStorage.getItem('access_token');
    }

    private getAuthHeaders(): HttpHeaders {
        const token = this.getAuthToken();
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        });
    }
}
